import { combineReducers } from '@ngrx/store';

import { UiUpsellRootReducer as ui } from '@upsell/store/reducers/ui/index';
import { upsellReducer as upsell } from '@app/modules/upsell/store/reducers/upsell-mobile.reducer';
import {
  upsellForDesktopReducer as upsellForDesktop
} from '@upsell/store/reducers/upsell-desktop.reducer';
import {
  upsellPayloadReducer as upsellPayload
} from '@upsell/store/reducers/upsell-payload.reducer';
import { clickedUpsellReducer as clickedUpsell } from '@upsell/store/reducers/clicked-upsell.reducer';

export const upsellRootReducer = combineReducers({
  upsell,
  upsellForDesktop,
  upsellPayload,
  clickedUpsell,
  ui
});
